// Oferta por segmento no fim do onboarding. Uma oferta principal por pessoa; o Douto segue como passo seguinte
// para todos os segmentos (inclusive estudante, decisão do Cadu). Links só com UTM e o parâmetro seg.

// Amostra grátis do Kit (página com o formulário SendFox), caminho confirmado no site publicado.
const PRESCRITORES_URL = 'https://prescritores.com/guia-gratis/';
// Link do PDM PRO ainda não definido: sem URL, a oferta cai para a amostra do Kit (ver offerFor).
const PDM_PRO_URL = '';

export const OFFERS = {
  kit_plantonista: {
    id: 'kit_plantonista',
    titulo: 'Amostra grátis do Kit do Plantonista',
    texto: 'Veja uma amostra do material de conduta e prescrição, com a fonte de cada recomendação.',
    cta: 'Ver a amostra grátis',
    url: PRESCRITORES_URL,
  },
  kit_receitas: {
    id: 'kit_receitas',
    titulo: 'Amostra grátis do Kit, com receitas-modelo',
    texto: 'Veja uma amostra do guia de prescrição e das receitas-modelo para o consultório.',
    cta: 'Ver a amostra grátis',
    url: PRESCRITORES_URL,
  },
  kit_residente: {
    id: 'kit_residente',
    titulo: 'Amostra grátis do Kit do Plantonista',
    texto: 'Conduta e prescrição direto ao ponto, para consultar no meio do plantão.',
    cta: 'Ver a amostra',
    url: PRESCRITORES_URL,
  },
  kit_estudante: {
    id: 'kit_estudante',
    titulo: 'Amostra grátis do Kit',
    texto: 'Veja como conduta e prescrição aparecem com a fonte de cada recomendação, para estudar com mais segurança.',
    cta: 'Ver a amostra grátis',
    url: PRESCRITORES_URL,
  },
  amostra_generica: {
    id: 'amostra_generica',
    titulo: 'Amostra grátis',
    texto: 'Veja uma amostra do material de consulta rápida do ecossistema EI DOC.',
    cta: 'Ver a amostra grátis',
    url: PRESCRITORES_URL,
  },
  pdm_pro: {
    id: 'pdm_pro',
    titulo: 'PDM PRO: presença digital para médicos',
    texto: 'Para quem quer atrair pacientes e construir presença digital com método.',
    cta: 'Conhecer o PDM PRO',
    url: PDM_PRO_URL,
  },
};

/** Escolhe a oferta principal a partir do perfil válido. Sem perfil, devolve a amostra genérica. */
export function offerFor(answers = {}) {
  const { segmento, contexto, necessidade } = answers;
  if (segmento === 'medico') {
    if (necessidade === 'presenca_digital' && OFFERS.pdm_pro.url) return OFFERS.pdm_pro;
    if (contexto === 'consultorio') return OFFERS.kit_receitas;
    return OFFERS.kit_plantonista;
  }
  if (segmento === 'residente') return OFFERS.kit_residente;
  if (segmento === 'estudante') return OFFERS.kit_estudante;
  return OFFERS.amostra_generica;
}

export function offerHref(offer, segmento) {
  const url = new URL(offer.url);
  const seg = segmento || 'desconhecido';
  url.search = new URLSearchParams({
    utm_source: 'minimental',
    utm_medium: 'onboarding',
    utm_campaign: 'amostra_kit',
    utm_content: `${seg}_${offer.id}`,
    seg,
  }).toString();
  return url.toString();
}
